import { ItemText, Main } from 'components/ActionStyles/ActionStyles'
import AntdAvatar from 'components/Avatar'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import ResumeDownload from 'components/ResumeDownload'
import ResumePreview, { getUploadedCvUrl } from 'components/ResumePreview'
import EmailIcon from 'components/icons/EmailIcon'
import PhoneIcon from 'components/icons/PhoneIcon'
import VerticalThreeDots from 'components/icons/VerticalThreeDots'
import YellowStartIcon from 'components/icons/YellowStartIcon'
import {
  ContactFlex,
  DropBtn,
  DropDown,
  EmailIdDiv,
  HeaderFlex,
  IconSpan,
  NameDive,
  RatingText,
  RatingsDiv,
  StatusWrapper,
  StyledTab,
  TestDetailsFlex,
  TestFlex,
  ThreeDotsDiv,
  TopFlex,
  TopRightFlex,
  YellowStartSpan,
} from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/style'
import DriveStatus from 'modules/Exp-Candidates/ViewDriveRole/IndividualDriveTable/DriveStatus/index'
import RoundsSteps from 'modules/Exp-Candidates/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/index'
import React from 'react'
import { useSelector } from 'react-redux'

const { TabPane } = StyledTab

const CandidateInfo = ({
  candidateInfo,
  setCandidateInfo,
  scheduleDrawer,
  setScheduleDrawer,
  createSlotDrawer,
  setCreateSlotDrawer,
  candidateDetails,
  rolesMetrics,
  candidateInterviewDetails,
  candidateInfoData,
  updateInterviewStatus,
  driveId,
  roleId,
  getCandidateList,
  selectedRoundType,
  getRoleMetrics,
  setSelectedCandidate,
  setSelectedCandidateId,
  getSingleCandidateInterviewDetails,
  setReleaseOffer,
  isUpload,
}) => {
  // Show the CV the candidate uploaded for this role; fall back to the
  // generated system resume only when they never uploaded one.
  const uploadedCvUrl = getUploadedCvUrl(candidateInfoData)
  const candidateFullName =
    `${candidateDetails?.firstName || ''} ${candidateDetails?.lastName || ''}`.trim() ||
    'This candidate'
  const onClickOffer = () => {
    setReleaseOffer(true)
    setCandidateInfo(false)
  }

  const promotionData = useSelector(state => state?.corporate?.promotionData)

  const items = [
    {
      key: 'download',
      label: (
        <ResumeDownload
          triggerButton={<ItemText weight={400}>Download Resume</ItemText>}
          studentDetails={candidateDetails}
          roleId={roleId}
        />
      ),
    },
    candidateInfoData?.status === 'SELECTED' && {
      key: 'upload',
      label: (
        <ItemText weight={400} onClick={onClickOffer}>
          Release Offer
        </ItemText>
      ),
    },
  ]

  const title = () => {
    return (
      <HeaderFlex row spaceBetween centerVertically>
        <TopFlex row centerVertically>
          <AntdAvatar
            size={90}
            src={candidateDetails?.profileUrl}
            IconName={candidateDetails?.firstName?.toUpperCase()?.charAt(0)}
          />
          <ContactFlex column>
            <Flex centerVertically>
              <NameDive>
                {candidateDetails?.firstName} {candidateDetails?.middelName}{' '}
                {candidateDetails?.lastName}{' '}
              </NameDive>
              <StatusWrapper>
                <DriveStatus
                  status={candidateInfoData?.status}
                  offerStatus={candidateInfoData?.offerStatus}
                />
              </StatusWrapper>
            </Flex>
            {!!candidateDetails?.admin?.email && (
              <EmailIdDiv>
                <IconSpan>
                  <EmailIcon />
                </IconSpan>
                {candidateDetails?.admin?.email}
              </EmailIdDiv>
            )}
            {!!candidateDetails?.studentPersonalProfile?.phoneNumber && (
              <EmailIdDiv>
                <IconSpan>
                  <PhoneIcon />
                </IconSpan>
                {candidateDetails?.studentPersonalProfile?.phoneNumber}
              </EmailIdDiv>
            )}
          </ContactFlex>
        </TopFlex>
        <TopRightFlex row spaceBetween centerVertically>
          <Flex row centerVertically>
            <TestDetailsFlex column>
              <RatingsDiv>
                {Number(candidateInfoData?.rating)?.toFixed(2)}
                <YellowStartSpan>
                  <YellowStartIcon />
                </YellowStartSpan>
              </RatingsDiv>
              <RatingText>RATINGS</RatingText>
            </TestDetailsFlex>

            <TestFlex column>
              <RatingsDiv>{candidateInfoData?.stage?.toLowerCase()}</RatingsDiv>
              <RatingText>Stage</RatingText>
            </TestFlex>
          </Flex>
          <ThreeDotsDiv>
            <Main>
              <DropDown menu={{ items }} trigger={['click']}>
                <DropBtn>
                  <VerticalThreeDots />
                </DropBtn>
              </DropDown>
            </Main>
          </ThreeDotsDiv>
        </TopRightFlex>
      </HeaderFlex>
    )
  }
  const content = () => {
    return (
      <div>
        <StyledTab>
          {!isUpload && (
            <TabPane tab={<>Interview</>} key="1">
              <RoundsSteps
                candidateInfo={candidateInfo}
                setCandidateInfo={setCandidateInfo}
                scheduleDrawer={scheduleDrawer}
                setScheduleDrawer={setScheduleDrawer}
                createSlotDrawer={createSlotDrawer}
                setCreateSlotDrawer={setCreateSlotDrawer}
                rolesMetrics={rolesMetrics}
                candidateInterviewDetails={candidateInterviewDetails}
                candidateInfoData={candidateInfoData}
                updateInterviewStatus={updateInterviewStatus}
                driveId={driveId}
                roleId={roleId}
                getCandidateList={getCandidateList}
                selectedRoundType={selectedRoundType}
                getRoleMetrics={getRoleMetrics}
                setSelectedCandidate={setSelectedCandidate}
                setSelectedCandidateId={setSelectedCandidateId}
                getSingleCandidateInterviewDetails={
                  getSingleCandidateInterviewDetails
                }
              />
            </TabPane>
          )}
          <TabPane tab={<>Resume</>} key="2">
            {/* The uploaded CV only — a candidate with no upload reads as
                "No resume found" rather than a resume we generated. */}
            <ResumePreview
              cvUrl={uploadedCvUrl}
              studentId={candidateDetails?.id}
              roleId={roleId}
              candidateName={candidateFullName}
            />
          </TabPane>
        </StyledTab>
      </div>
    )
  }
  return (
    <Drawer
      width="65%"
      title={title()}
      placement="right"
      padding="0 30px 30px 30px"
      visible={candidateInfo}
      content={content()}
      destroyOnClose={true}
      onClose={() => {
        setSelectedCandidate([])
        setSelectedCandidateId([])
        setCandidateInfo(false)
      }}
    />
  )
}

export default CandidateInfo
